import React from "react";

import s from "./ClearAlarmDialog.module.scss";
import { Dialog } from "../../components/Dialog/Dialog";
import { Alarm } from "../../models/Alarm";

interface IClearAlarmDialog {
	isOpen: boolean;
	alarm: Alarm;
	submitAlarm: (reason: string) => void;
	submitReason: (reason: string) => void;
	cancel: () => void;
}

const ClearAlarmDialog = ({ isOpen, alarm, submitAlarm, submitReason, cancel }: IClearAlarmDialog): JSX.Element => {
	const [reason, setReason] = React.useState<string>(alarm.reason || "");

	React.useEffect(() => {
		setReason(alarm.reason || "");
	},[alarm]);

	const reasonOnChangeHandler = (event: any) => {
		event.preventDefault();
		setReason(event.target.value);
	};

	const actions = [
		{
			title: "Submit Reason",
			func() {
				!alarm.clearedBy ? submitAlarm(reason) : submitReason(reason);
			},
		},
		{
			title: "Clear Reason",
			func() {
				submitReason("");
			},
		},
		{
			title: "Cancel",
			func() {
				cancel();
			},
		},
	];

	return (
		<Dialog title={"Clear Alarm"}
			isOpen={isOpen}
			testId="dialog-clear-alarms"
			actions={actions}>
			<div className={s.host}>
				<div className={s.host__column}>
					<div className={[s.host__property, s.property].join(" ")}>
						<div className={s.property__row}>
							<label className={s.property__label}>Reason</label>
							<input className={s.property__input} type="text" value={reason} onChange={reasonOnChangeHandler}/>
						</div>
					</div>
				</div>
			</div>
		</Dialog>
	);
};

export default ClearAlarmDialog;
